import { useCallback, useEffect, useState, useRef } from "react";
import { MainContainer, Sidebar, ExpansionPanel, ConversationList, Conversation, Avatar, ChatContainer, ConversationHeader, InfoButton, MessageGroup, Message, MessageList, MessageInput, TypingIndicator, AvatarGroup, InputToolbox } from "@chatscope/chat-ui-kit-react";
import { useChat, ChatMessage, MessageContentType, MessageDirection, AvatarPosition, MessageStatus, Conversation as Convo, ConversationRole, Participant, TypingUsersList, Presence, UserStatus } from "../@chatscope/use-chat/src";
import { MessageContent, TextContent, User } from "../@chatscope/use-chat/src";
import { SearchBar } from "./SearchBar";
import { getUserData, getUserPhoto } from "../utils/peopleSearch";
import "../components/Ping.css";
import Button from '@mui/material/Button';
import { useMsal } from "@azure/msal-react";
import Modal from '@mui/material/Modal';
import defaultAvatar from "../assets/Avatar.png";
import { ConnectionState } from "../@chatscope/use-chat/src/enums";
import { useAppInsightsContext, useTrackEvent } from "@microsoft/applicationinsights-react-js";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DOMPurify from 'dompurify';
import emojiData from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import type {AriaAttributes, DOMAttributes} from "react";

declare module 'react' {
  interface HTMLAttributes<T> extends AriaAttributes, DOMAttributes<T> {
    as?: string | typeof MessageInput;
  }
}

export const thisUser = {
    gmid: "",
    name: "",
    avatar: defaultAvatar, //TODO PROFILE PIC need to change this to the actual avatar
    userName: "",
    presence: new Presence({ status: UserStatus.Unknown, description: "" }),
    firstName: "",
    lastName: ""
}


export const Chat = ({ user }: { user: User }) => {

    const appInsights = useAppInsightsContext();
    const trackStartConversation = useTrackEvent(appInsights, "start_conversation", {});

    // Get all chat related values and methods from useChat hook 
    const {
        currentMessages, conversations, activeConversation, setActiveConversation, sendMessage, getUser, currentMessage, setCurrentMessage, getCurrentUser,
        sendTyping, setCurrentUser, addConversation, removeConversation, addUser, connectionStatus, startConnection, saveSettingsFile, loadSettingsFile
    } = useChat();

    const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
    const [selectedUsersInfo, setSelectedUsersInfo] = useState<User[]>([]);
    const [favorites, setFavorites] = useState<User[]>([]);
    const { instance } = useMsal();
    const [searchResults, setSearchResults] = useState([]);
    const [isOptInPopupOpen, setIsOptInPopupOpen] = useState(false);
    const [isOptInLinkClicked, setIsOptInLinkClicked] = useState(false);
    const [optedIn, setOptedIn] = useState(false);
    const [settingsFile, setSettingsFile] = useState<any>({});
    const [displayUI, updateUI] = useState(false);
    const [newConvoToggle, setNewConvoToggle] = useState(false);
    const [renameConversationOption, setRenameConversationOption] = useState(false);
    const [groupNames, setGroupNames] = useState<any>({});
    const [addPeopleToggle, setAddPeopleToggle] = useState(false);
    const [newConversationId, setNewConversationId] = useState<number>(0);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
    const [anchorEl3, setAnchorEl3] = useState<null | HTMLElement>(null);
    const [sidebarVisible, setSidebarVisible] = useState(true);
    const [sidebarStyle, setSidebarStyle] = useState({});
    const [chatContainerStyle, setChatContainerStyle] = useState({});
    const [conversationContentStyle, setConversationContentStyle] = useState({});
    const [conversationAvatarStyle, setConversationAvatarStyle] = useState({});
    const [isMobileSize, setMobileSize] = useState(false);
    const [imgSrc, setImgSrc] = useState<string | null>(null);
    const [isBigImage, setIsBigImage] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [mobileMenu, setMobileMenu] = useState(false);
    const [closeToBottom, setCloseToBottom] = useState(false);
    const [bottomOffset, setBottomOffset] = useState<number>(0);
    const currentUser: User<any> = getCurrentUser() as User<any>;

    const handleBackClick = () => setSidebarVisible(!sidebarVisible);

    const emojiButton = '😃';
    const [showPicker, setShowPicker] = useState(false);
    const pickerRef = useRef<HTMLDivElement | null>(null);
    
    const handleClickOutside = (e: MouseEvent) => {
        if (pickerRef.current && !pickerRef.current.contains(e.target as Node)) {
            setShowPicker(false);
            console.log("handleClickOutside:  removeEventListener");
            document.removeEventListener('mousedown', handleClickOutside);
        }
    };

    const togglePicker = () => {
        if (showPicker) {
            document.removeEventListener('mousedown', handleClickOutside);
            setShowPicker(false);
        }
        else {
            document.addEventListener('mousedown', handleClickOutside);
            setShowPicker(true);
        }
    };

    const handleAddEmoji = (emoji: any) => {
        togglePicker();
        handleChange(currentMessage + emoji.native);
    }

    useEffect(() => {
        if (window.innerWidth < 600) {
            setMobileSize(true);
        }
    }, [window.innerWidth]);

    const handleResize = () => {
        if (window.innerWidth < 600) {
            if (activeConversation && !mobileMenu) {
                setSidebarStyle({ display: 'none' });
                setSidebarVisible(true);
            }
            setMobileSize(true);
        } else {
            setSidebarStyle({});
            setMobileSize(false);
        }
    };

    useEffect(() => {
        if ((sidebarVisible && isMobileSize) || mobileMenu) {
            setSidebarStyle({
                display: "flex",
                flexBasis: "auto",
                width: "100%",
                maxWidth: "100%"
            });
            setChatContainerStyle({ display: "none" })
        }
        else if (isMobileSize && !mobileMenu) {
            setSidebarStyle({ display: "none" });
            setChatContainerStyle({});
        }
        else {
            setSidebarStyle({});
            setChatContainerStyle({});
        }
    }, [sidebarVisible, isMobileSize, mobileMenu]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        console.log("sidebarVisible: ", sidebarVisible, "mobile menu: ", mobileMenu);
    }, [sidebarVisible, mobileMenu]);

    const handleConversationClick = useCallback(() => {
        if (sidebarVisible && !mobileMenu) {
            setSidebarVisible(false);
        }
        else if (!sidebarVisible && mobileMenu) {
            setSidebarVisible(true);
            setMobileMenu(false);
        }

    }, [sidebarVisible, mobileMenu, setSidebarVisible]);

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (isMobileSize && sidebarVisible) {
            setMobileMenu(true);
        }
        if (event.currentTarget.getBoundingClientRect().bottom >= window.innerHeight - 300) {
            const targetRect = event.currentTarget.getBoundingClientRect();
            const distanceToBottom = window.innerHeight - targetRect.bottom;
            const calcBottomOffset = -350 + distanceToBottom;
            setBottomOffset(calcBottomOffset);
            setCloseToBottom(true);
        }
        else {
            setCloseToBottom(false);
        }
        setAnchorEl(event.currentTarget);
        setAnchorEl2(event.currentTarget);
    };

    useEffect(() => {
    }, [mobileMenu]);

    const handleMenuClose = () => {
        if (!mobileMenu && !sidebarVisible) {
            // Do not call setMobileMenu and setSidebarVisible
        } else {
            setMobileMenu(false);
            setSidebarVisible(true);
        }
        setAnchorEl(null);
    };

    const handleHoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl3(event.currentTarget);
    }

    const handleHoverClose = () => {
        setAnchorEl3(null);
    };

    const handleCancel = () => {
        setAddPeopleToggle(false);
        setSelectedUsersInfo([]);
        setSelectedUsers([]);
        setAnchorEl2(null);
    }

    async function searchClick(e: any, searchResults: any) {
        try {
            thisUser.gmid = searchResults.userPrincipalName;
            thisUser.name = searchResults.name;
            thisUser.name = searchResults.displayName.props.children[0] !== undefined ? searchResults.displayName.props.children[0] : thisUser.name;
            thisUser.userName = searchResults.displayName;
            thisUser.presence = new Presence({ status: UserStatus.Unknown, description: "" });
            thisUser.firstName = searchResults.givenName;
            thisUser.lastName = searchResults.surname;
            thisUser.avatar = await getUserPhoto(instance, searchResults.userPrincipalName);
        } catch (error) {
            console.log(`[searchClick] Error: ${error}`)
        }
    }

    const SearchResultsList = ({ searchResults }: { searchResults: any }) => {
        return (
            <div className="search-list">
                {
                    searchResults.map((searchResult: any) => {
                        return (
                            <div
                                key={searchResult.id}
                                className="search-results"
                                id="searchName"
                                onClick={(e) => {
                                    searchClick(e, searchResult);
                                    var upn = searchResult.userPrincipalName;
                                    handleUserSelect(upn);
                                }}
                            >
                                {searchResult.displayName}
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    const handleChange = (value: string) => {
        // Send typing indicator to the active conversation
        // You can call this method on each onChange event
        // because sendTyping method can throttle sending this event
        // So typing event will not be send to often to the server
        setCurrentMessage(value);

        if (/<img[^>]+src="[^">]+"[^>]*>/i.test(value)) {
            let imgVal = value.match(/<img[^>]+src="([^">]+)"[^>]*>/i);
            let newImgSrc = imgVal ? imgVal[1] : null;
            setImgSrc(newImgSrc);
        }
        else {
            setImgSrc(null);
        }

        if (activeConversation) {
            sendTyping({
                conversationId: activeConversation?.id,
                isTyping: true,
                userId: user.id,
                content: value, // Note! Most often you don't want to send what the user types, as this can violate his privacy!
                throttle: true
            });
        }
    }

    useEffect(() => {
        if (imgSrc) {
            fetch(imgSrc)
                .then(response => response.blob())
                .then(blob => {
                    const maxSize = (parseInt(process.env.REACT_APP_MAX_MESSAGE_SIZE_KB as string) || 32) * 1024; // 32KB as default size
                    if (blob.size > maxSize) {
                        setIsBigImage(true);
                    }
                });
        } else {
            setIsBigImage(false);
        }
    }, [imgSrc]);


    const handleSend = (text: string) => {

        const message = new ChatMessage({
            id: "", // Id will be generated by storage generator, so here you can pass an empty string
            content: text as unknown as MessageContent<TextContent>,
            contentType: MessageContentType.TextHtml,
            senderId: user.id,
            senderName: "Me",
            direction: MessageDirection.Outgoing,
            avatarPosition: AvatarPosition.Right,
            createdTime: new Date(),
            // createdTime: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            status: MessageStatus.Sent
        });

        if (activeConversation) {
            sendMessage({
                message,
                conversationId: activeConversation.id,
                senderId: user.id,
                senderName: user.username
            });
        }
    };

    function createConversation(userId: string, upn: string): Convo {
        return new Convo({
            id: "",
            participants: [
                new Participant({
                    id: userId,
                    role: new ConversationRole([]),
                    upn: upn
                })
            ],
            unreadCounter: 0,
            typingUsers: new TypingUsersList({ items: [] }),
            draft: ""
        });
    }


    const removeFromSelectedUsers = (userId: string) => {
        if (userId) {
            setSelectedUsersInfo(prevUsers => prevUsers.filter(user => user.upn !== userId));
            setSelectedUsers(prevUsers => prevUsers.filter(user => user !== userId));
        }
    };

    const addPeople = () => {
        setAddPeopleToggle(!addPeopleToggle);
    }

    const addUserToExistingConversation = () => {
        for (const userInfo of selectedUsersInfo) {
            activeConversation?.participants.push(
                new Participant({
                    id: userInfo.id,
                    role: new ConversationRole([]),
                    upn: userInfo.upn
                })
            );
            addUser(userInfo);
        }
        setSelectedUsers([]);
        setSelectedUsersInfo([]);
        setAddPeopleToggle(false);
    }

    const startGroupConversation = async () => {
        // Create a new conversation with selected users
        if (selectedUsers.length === 0) {
            return;
        }
        const gmid = user.id;
        const upn = user.upn;
        const newConversation = createConversation(gmid, upn);
        for (const userInfo of selectedUsersInfo) {
            newConversation.participants.push(
                new Participant({
                    id: userInfo.id,
                    role: new ConversationRole([]),
                    upn: userInfo.upn
                })
            );
            addUser(userInfo);
        }

        addUser(user);

        // Add the new conversation to the list
        addConversation(newConversation);
        // send the event to app insights
        trackStartConversation({ "conversationId": newConversation.id });

        setNewConversationId(newConversationId + 1);
        newConversation.description = newConversationId.toString();

        // Clear the selected users
        setSelectedUsers([]);
        setSelectedUsersInfo([]);
        toggleNewConvo();
        setActiveConversation(newConversation.id);
    };

    const handleUserSelect = async (userId: string) => {
        if (selectedUsers.includes(userId)) {
            setSelectedUsers(selectedUsers.filter(id => id !== userId));
        } else {
            const userInfo = await getUserData(instance, userId);
            if (userInfo) {
                setSelectedUsers([...selectedUsers, userId]);
                setSelectedUsersInfo([...selectedUsersInfo, userInfo]);
            }
        }
    };

    const handleFavoritesSelect = async (userId: string) => {
        const favoriteUser = favorites.find((favorite) => favorite.upn === userId);
        const newConversation = createConversation(user.id, user.upn);

        if (favoriteUser) {
            newConversation.participants.push(
                new Participant({
                    id: favoriteUser.id,
                    role: new ConversationRole([]),
                    upn: favoriteUser.upn
                })
            );
            addUser(favoriteUser);
        }

        addUser(user);

        // Add the new conversation to the list
        addConversation(newConversation);
        // send the event to app insights
        trackStartConversation({ "conversationId": newConversation.id });

        setActiveConversation(newConversation.id);
    }

    const handleGroupNameChange = (updatedGroupName: string) => {
        if (activeConversation) {
            const updatedGroupNames = { ...groupNames, [activeConversation.id]: updatedGroupName };
            setGroupNames(updatedGroupNames);
        }
    };

    const toggleNewConvo = () => {
        setNewConvoToggle(!newConvoToggle);
        if (selectedUsersInfo) {
            setSelectedUsersInfo([]);
            setSelectedUsers([]);
        }
        if (activeConversation) {
            setActiveConversation('');
        }
    };

    const loadSettingsFromStorage = async () => {
        const settings = await loadSettingsFile();
        const favorites = settings.favorites;
        const updatedFavorites = [];
        if (favorites.length > 0) {
            for (const upn of favorites) {
                const userInfo = await getUserData(instance, upn);
                updatedFavorites.push(userInfo);
            }
        }
        setFavorites(updatedFavorites);
        setSettingsFile(settings);
    }

    const handleOptInLinkClick = () => {
        setIsOptInLinkClicked(true);
    };

    const handleOptInClick = async () => {
        if (isOptInLinkClicked) {
            setIsOptInPopupOpen(false);
            const fileString = `${currentUser.id} settings.json`;
            settingsFile.settings.optedIn = true;
            setSettingsFile(settingsFile);
            const jsonSettings = JSON.stringify(settingsFile);
            const base64EncodedString = btoa(jsonSettings);
            saveSettingsFile(fileString, base64EncodedString);
        }
    };

    const renameConversation = () => {
        setRenameConversationOption(!renameConversationOption);
    }

    const getTypingIndicator = useCallback(() => {
        if (activeConversation) {
            const typingUsers = activeConversation.typingUsers;
            if (typingUsers.length > 0) {
                const typingUserId = typingUsers.items[0].userId;
                // Check if typing user participates in the conversation.
                if (activeConversation.participantExists(typingUserId)) {
                    const typingUser = getUser(typingUserId);
                    if (typingUser) {
                        return <TypingIndicator content={`${typingUser.username} is typing`} />
                    }
                }
            }
        }
        return undefined;
    }, [activeConversation, getUser],
    );

    useEffect(() => {
        setCurrentUser(user);
    }, [user, setCurrentUser]);

    useEffect(() => {
        if (settingsFile !== null && Object.keys(settingsFile).length !== 0) {
            updateUI(true);
            if (settingsFile.settings.optedIn === true) {
                setOptedIn(true);
            }
        }
    }, [settingsFile])

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!document.hidden && activeConversation) {
                setActiveConversation(activeConversation.id);
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [activeConversation]);

    useEffect(() => {
        let iconCount = conversations.map(c => c.unreadCounter);
        const iconCountSum = iconCount.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        if (iconCountSum > 0) {
            (navigator as any).setAppBadge && (navigator as any).setAppBadge(iconCountSum);
        } else {
            (navigator as any).clearAppBadge && (navigator as any).clearAppBadge();
        }
    })

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (connectionStatus === ConnectionState.Initial) {
            loadSettingsFromStorage();
        }
    }, [connectionStatus]);

    useEffect(() => {
    }, [groupNames]);

    useEffect(() => {
    }, [settingsFile]);

    useEffect(() => {
        setAddPeopleToggle(false);
    }, [activeConversation?.participants.length]);

    useEffect(() => {
        setIsOptInPopupOpen(true);
    }, []);

    const saveSettings = async (settings: any) => {
        try {
            const jsonSettings = JSON.stringify(settings);
            const base64EncodedString = btoa(jsonSettings);
            saveSettingsFile(`${currentUser.id} settings.json`, base64EncodedString);
        } catch (error) {
            console.error('[saveSettings] Error saving settings:', error);
        }
    }

    const addToFavorites = async () => {
        let participantId = "";
        if (activeConversation && activeConversation.participants.length === 2) {
            for (const userInfo of activeConversation.participants) {
                if (userInfo.upn === currentUser.upn) {
                    const index = activeConversation.participants.indexOf(userInfo);
                    participantId = activeConversation.participants[1 - index].id;
                }
            }
            try {
                setFavorites(prevFavorites => {
                    const updatedFavorites = [...prevFavorites];
                    const user = getUser(participantId);
                    if (user && !updatedFavorites.some(favorite => favorite.id === user.id)) {
                        updatedFavorites.push(user);
                    }
                    setSelectedUsersInfo([]);
                    setSelectedUsers([]);
                    const upnFavorites = updatedFavorites.map(user => user.upn);
                    settingsFile.favorites = upnFavorites;
                    setSettingsFile(settingsFile);
                    saveSettings(settingsFile);
                    return updatedFavorites;
                });
            } catch (error) {
                console.error('[addToFavorites] Error saving favorites:', error);
            }
        }
    };

    const removeFromFavorites = (userUpn: string) => {
        if (userUpn) {
            setFavorites(prevFavorites => prevFavorites.filter(user => user.upn !== userUpn));
            settingsFile.favorites = settingsFile.favorites.filter((user: string) => user !== userUpn);
            setSettingsFile(settingsFile);
            saveSettings(settingsFile);
        }
        else {
            const userUpnsToRemove = selectedUsersInfo.map((user) => user.upn);
            setFavorites(prevFavorites => prevFavorites.filter(user => !userUpnsToRemove.includes(user.upn)));
            settingsFile.favorites.filter((user: string) => !userUpnsToRemove.includes(user));
            setSettingsFile(settingsFile);
            saveSettings(settingsFile);
        }
    };

    return (
        <MainContainer responsive={false}>
            {((connectionStatus !== ConnectionState.Connected && connectionStatus !== ConnectionState.Initial) || !displayUI) && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    {(connectionStatus === ConnectionState.Connecting || !displayUI) &&
                        (<p>Attempting to Connect. Please wait...</p>)
                    }
                    {connectionStatus === ConnectionState.Disconnected &&
                        <Modal open={true} style={{ zIndex: 9999 }}>
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                backgroundColor: 'white',
                                padding: '25px',
                                borderRadius: '8px',
                                width: '20%',
                                height: '20%',
                                zIndex: '99999',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column'
                            }}>
                                <div style={{ fontSize: '14px', textAlign: 'center' }}>
                                    Connection lost. Click here to reconnect.
                                    <br />
                                    <br />
                                    <Button variant="contained" onClick={startConnection}>Reconnect</Button>
                                </div>
                            </div>
                        </Modal>
                    }
                </div>
            )}
            <>
                {!optedIn && displayUI && (connectionStatus === ConnectionState.Initial || connectionStatus === ConnectionState.Connected) && (

                    <Modal open={isOptInPopupOpen} onClose={() => { if (isOptInLinkClicked) setIsOptInPopupOpen(false); }}>
                        <div style={{ position: 'absolute', top: '50%', left: '50%', bottom: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '2%', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderRadius: '8px', width: '60%', height: '35%', overflowX: 'hidden', overflowY: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ position: 'relative', top: 0, right: 0 }}>
                            </div>
                            <div style={{ fontSize: '12px', textAlign: 'center' }}> Ping! is a tool to be used for real-time, short-lived, casual conversations and is NOT an appropriate tool for communications about subjects covered by a litigation hold or communications that constitute GM Business records. The full acceptable Usage policy for Ping! Is available at
                                <br></br>
                                <a href="https://gmweb.gm.com/sites/service/Pages/PingAup.aspx" target="blank" onClick={handleOptInLinkClick}> Ping! Acceptable Use Practices</a>.
                                <br></br>
                                By clicking “Accept”, you are confirming that you have read the full AUP and accept its terms.
                                <br></br>
                                <Button variant="contained" onClick={handleOptInClick} style={{ marginTop: '1%' }} disabled={!isOptInLinkClicked}>Accept</Button>
                            </div>
                        </div>
                    </Modal>
                )}

                {renameConversationOption && (
                    <Dialog open={renameConversationOption} onClose={renameConversation}
                        PaperProps={{
                            component: 'form',
                            onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                                event.preventDefault();
                                const formData = new FormData(event.currentTarget);
                                const formJson = Object.fromEntries((formData as any).entries());
                                const groupName = formJson.groupName;
                                handleGroupNameChange(groupName);
                                renameConversation();
                            },
                        }}>
                        <DialogContent>
                            <TextField
                                autoFocus
                                required
                                margin="dense"
                                id="name"
                                name="groupName"
                                label="Enter Group Name"
                                type="text"
                                fullWidth
                                variant="standard"
                            />
                        </DialogContent>
                        <DialogActions style={{ justifyContent: 'center' }}>
                            <Button onClick={renameConversation}>Cancel</Button>
                            <Button type="submit">Submit</Button>
                        </DialogActions>
                    </Dialog>
                )}

                {addPeopleToggle && (
                    <Popover
                        open={addPeopleToggle}
                        anchorEl={anchorEl2}
                        onClose={handleCancel}
                        anchorOrigin={{
                            vertical: closeToBottom ? bottomOffset : 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
                            <SearchBar conversationId={activeConversation?.id} />

                        </div>
                        {selectedUsersInfo.length > 0 && (
                            <div style={{ marginLeft: '8px' }}>
                                {selectedUsersInfo.map((user) => {
                                    return (
                                        <div key={user.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Avatar size="sm" src={user.avatar} />
                                                <span style={{ marginLeft: '8px' }}>{user.username}</span>
                                            </div>
                                            <IconButton onClick={() => removeFromSelectedUsers(user.upn)}>
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </Popover>
                )}
            </>
            <Sidebar position="left" scrollable={true} style={sidebarStyle}>
                <div>
                    <SearchBar />

                </div>
                {selectedUsersInfo.length > 0 && !addPeopleToggle && (
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', width: '100%' }}>
                        <div style={{ marginLeft: '8px', display: 'flex', flexWrap: 'wrap', width: '100%' }}>
                            {selectedUsersInfo.map((user, index) => {
                                return (
                                    <div key={user.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: '8px', marginBottom: '8px', zIndex: 1, width: '100%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Avatar size="sm" src={user.avatar} />
                                            <span style={{ marginLeft: '8px', zIndex: 1 }}>{user.username}</span>
                                        </div>
                                        <IconButton onClick={() => removeFromSelectedUsers(user.upn)} size="small">
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                );
                            })}
                        </div>
                        <Button onClick={startGroupConversation}>Start</Button>
                    </div>
                )}
                <ConversationList>
                    {conversations.map((c) => {
                        // Helper for getting the data of the first participant
                        const [avatar, name] = (() => {
                            let participant;
                            if (c.participants.length === 2) {
                                for (const userInfo of c.participants) {
                                    if (userInfo.id === currentUser.id) {
                                        const index = c.participants.indexOf(userInfo);
                                        participant = c.participants[1 - index];
                                    }
                                }
                                if (participant) {
                                    const user = getUser(participant.id);
                                    if (user) {
                                        return [
                                            <Avatar src={user.avatar} name={user.username} status={user.presence.status === UserStatus.Available ? "available" : "invisible"} style={conversationAvatarStyle} />,
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {user.username}
                                                </div>
                                                <IconButton style={{ marginLeft: 'auto' }} onClick={handleMenuOpen}>
                                                    <MoreHorizIcon />
                                                </IconButton>
                                            </div>
                                        ];
                                    }
                                }
                            }
                            else if (c.participants.length > 2) {
                                let defaultGroupName = "";
                                const avatars = c.participants.slice(0, 5).map((participant, index) => {
                                    const user = getUser(participant.id);
                                    if (user) {
                                        if (user.id !== currentUser.id) {
                                            defaultGroupName = defaultGroupName + user.firstName;
                                            if (index !== c.participants.length - 1 && !(index === c.participants.length - 2 && c.participants[index + 1].id === currentUser.id)) {
                                                defaultGroupName = defaultGroupName + ", ";
                                            }
                                            return <Avatar key={user.id} src={user.avatar} name={user.username} status={user.presence.status === UserStatus.Available ? "available" : "invisible"} style={conversationAvatarStyle} />;
                                        }
                                    }
                                    return null;
                                });
                                if (user) {
                                    let groupName = c.id ? groupNames[c.id] : undefined;
                                    let avatarMargin;
                                    if (avatars.length === 3) {
                                        avatarMargin = 40;
                                    } else if (avatars.length === 4) {
                                        avatarMargin = 60;
                                    } else if (avatars.length >= 5) {
                                        avatarMargin = 90;
                                    }
                                    return [
                                        <AvatarGroup size="md" max={4} hoverToFront={true} style={{ flexWrap: "nowrap", marginRight: `${avatarMargin}px` }}>
                                            {avatars}
                                        </AvatarGroup>,
                                        <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center", maxWidth: '360px' }}>
                                            <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: '220px' }}>
                                                {groupName ? groupName : defaultGroupName}
                                            </div>
                                            <IconButton style={{ marginLeft: 'auto' }} onClick={handleMenuOpen} >
                                                <MoreHorizIcon />
                                            </IconButton>
                                        </div>
                                    ];
                                }
                            }
                            return [undefined, undefined];
                        })();

                        return (
                            <Conversation
                                key={c.id}
                                unreadCnt={c.id === (activeConversation?.id ?? '') ? 0 : c.unreadCounter}
                                onClick={() => {
                                    setActiveConversation(c.id);
                                    handleConversationClick();
                                }}
                            >
                                {avatar}
                                <Conversation.Content name={name} style={conversationContentStyle} />
                            </Conversation>
                        );
                    })}
                </ConversationList>
                <ExpansionPanel
                    open
                    title="Favorites"
                >
                    <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {favorites.sort((a, b) => a.username.localeCompare(b.username)).map((user) => {
                            const handleUserClick = () => {
                                if (!selectedUsers.includes(user.upn)) {
                                    handleFavoritesSelect(user.upn);
                                }
                            };
                            return (
                                <div key={user.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    <div onClick={handleUserClick} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                        <Avatar size="sm" src={user.avatar} />
                                        <span style={{ marginLeft: '8px' }}>{user.username}</span>
                                    </div>
                                    <span style={{ marginLeft: 'auto' }}>
                                        <IconButton onClick={() => removeFromFavorites(user.upn)}>
                                            <CloseIcon />
                                        </IconButton>
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </ExpansionPanel>
            </Sidebar>
            <ChatContainer style={chatContainerStyle}>
                {activeConversation && (
                    <ConversationHeader key={activeConversation.id}>
                        {isMobileSize && (
                            <ConversationHeader.Back onClick={handleBackClick} />
                        )}
                        <ConversationHeader.Content>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {activeConversation.participants.slice(0, Math.floor(windowWidth / 200)).map(p => {
                                    const [avatar, name] = (() => {
                                        if (p) {
                                            const user = getUser(p.id);
                                            if (user && user.id !== currentUser.id) {
                                                if (user.presence.status === UserStatus.Available) {
                                                    return [<Avatar size="sm" src={user.avatar} status="available" />, user.username];
                                                } else {
                                                    return [<Avatar size="sm" src={user.avatar} status="invisible" />, user.username];
                                                }
                                            }
                                        }
                                        return [undefined, undefined];
                                    })();

                                    return (
                                        <div key={p.id} style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                            {avatar}
                                            <span style={{ marginLeft: '8px' }}>{name}</span>
                                        </div>
                                    );
                                })}
                                {(activeConversation.participants.length - Math.floor(windowWidth / 200)) > 0 && (
                                    <div style={{ paddingRight: '25px' }}>
                                        <Typography
                                            aria-owns={Boolean(anchorEl3) ? 'mouse-over-popover' : undefined}
                                            aria-haspopup="true"
                                            onMouseEnter={handleHoverOpen}
                                            onMouseLeave={handleHoverClose}
                                        >
                                            +{(activeConversation.participants.length - Math.floor(windowWidth / 200)).toString()}
                                        </Typography>
                                        <Popover
                                            id="mouse-over-popover"
                                            sx={{
                                                pointerEvents: 'none',
                                            }}
                                            open={Boolean(anchorEl3)}
                                            anchorEl={anchorEl3}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            onClose={handleHoverClose}
                                            disableRestoreFocus
                                        >
                                            {activeConversation.participants.slice(Math.floor(windowWidth / 200)).map(p => {
                                                const user = getUser(p.id);
                                                if (user) {
                                                    if (user.presence.status === UserStatus.Available) {
                                                        return (
                                                            <div key={p.id} style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                                <Avatar size="sm" src={user.avatar} status="available" />
                                                                <span style={{ marginLeft: '8px' }}>{user.username}</span>
                                                            </div>
                                                        );
                                                    } else {
                                                        return (
                                                            <div key={p.id} style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                                                                <Avatar size="sm" src={user.avatar} status="invisible" />
                                                                <span style={{ marginLeft: '8px' }}>{user.username}</span>
                                                            </div>
                                                        );
                                                    }
                                                }
                                                return [undefined, undefined];
                                            })}
                                        </Popover>
                                    </div>
                                )}
                                <div style={{ position: 'absolute', right: '0' }}>
                                    <IconButton onClick={handleMenuOpen}>
                                        <MoreHorizIcon />
                                    </IconButton>
                                    <Menu
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                    >
                                        <MenuItem onClick={() => {
                                            setAddPeopleToggle(true);
                                            handleMenuClose();
                                        }}>Add people</MenuItem>
                                        {activeConversation.participants.length === 2 && (
                                            <MenuItem onClick={() => {
                                                handleMenuClose();
                                                addToFavorites();
                                            }}>Add to favorites</MenuItem>
                                        )}
                                        {activeConversation.participants.length > 2 && (
                                            <MenuItem onClick={() => {
                                                handleMenuClose();
                                                renameConversation();
                                            }}>Rename chat</MenuItem>
                                        )}
                                        <MenuItem onClick={() => {
                                            removeConversation(activeConversation.id, true);
                                            handleMenuClose();
                                            setSidebarVisible(true);
                                        }}>Delete conversation</MenuItem>
                                    </Menu>
                                </div>
                            </div>
                        </ConversationHeader.Content>
                    </ConversationHeader>
                )}
                <MessageList typingIndicator={getTypingIndicator()}>
                    <MessageList.Content>
                        {activeConversation && currentMessages.map(g => (
                            <MessageGroup key={g.id} direction={g.direction} avatarPosition={g.avatarPosition} style={{ zIndex: 1, marginBottom: '20px' }}>
                                <Avatar>
                                    {g.senderId === currentUser.id ? (
                                        <Avatar key={currentUser.id} src={currentUser.avatar} />
                                    ) : (
                                        <Avatar key={g.senderId} src={getUser(g.senderId)?.avatar} />
                                    )}
                                </Avatar>
                                <MessageGroup.Header>{g.senderName} at {g.createdTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</MessageGroup.Header>
                                <MessageGroup.Messages>
                                    {g.messages.map((m: ChatMessage<MessageContentType>) => {
                                        let payloadContent;
                                        let contentWithoutSpan = m.content.toString();
                                        if (m.content.toString().includes('<a href')) {
                                            contentWithoutSpan = DOMPurify.sanitize(contentWithoutSpan, { ALLOWED_TAGS: [] });
                                        }
                                        const urlRegex = /(https?:\/\/[^\s]+)/g;
                                        const contentWithUrls = contentWithoutSpan.replace(urlRegex, url => `<a href="${url}" target="_blank">${url}</a>`);
                                        payloadContent = contentWithUrls.replace(/<span\b[^>]*>(.*?)<\/span>/gi, '$1');
                                        return (
                                            <Message key={m.id} avatarPosition={m.avatarPosition} model={{
                                                type: "html",
                                                payload: payloadContent,
                                                direction: m.direction,
                                                position: "normal"
                                            }} />
                                        )
                                    })}
                                </MessageGroup.Messages>
                            </MessageGroup>
                        ))}

                        <div style={{ display: 'flex', flexDirection: 'column', top: 'inherit', zIndex: 999 }} >
                            <div style={{ position: 'fixed', bottom: '74px' }}>
                                {
                                    activeConversation && activeConversation.participants.some(p => {
                                        const user = getUser(p.id);
                                        return user && (user.presence.status === UserStatus.Unknown || user.presence.status === UserStatus.Invisible);
                                    }) && (
                                        <div style={{ color: 'dimgray', fontSize: '12px', marginTop: 'auto', marginLeft: '0px', backgroundColor: 'white' }}>
                                            <ErrorOutlineIcon fontSize="small" style={{ paddingBottom: '4px' }} />
                                            Offline participants will not receive messages
                                        </div>
                                    )}
                            </div>
                        </div>
                        <div style={{ display: 'flex', position: 'fixed', flexDirection: 'column', justifyContent: 'flex-end', top: 'inherit', bottom: '75px', right: '35px' }}>
                            {isBigImage && (
                                <div style={{ color: '#6ea9d7', fontSize: '12px', marginTop: 'auto', marginLeft: '40px', marginBottom: '75px', backgroundColor: 'white' }}>
                                    <ErrorOutlineIcon fontSize="small" style={{ paddingBottom: '2px' }} />
                                    This image is too big
                                </div>
                            )}
                        </div>
                    </MessageList.Content>
                </MessageList>
                <div as={MessageInput} style={{ }}>
                    <div style={{ position: 'relative'}} ref={pickerRef}>
                    <div style={{ position: 'absolute', bottom: '-40px', left: '6px', cursor: 'pointer', zIndex: '10'}} onClick={activeConversation ? togglePicker : undefined}>{emojiButton}</div>                    {showPicker && (
                        <div style={{ position: 'absolute', bottom: '5px', left: '5px' }}>
                            <Picker data={emojiData} previewPosition="none" exceptEmojis={["relaxed","middle_finger"]} onEmojiSelect={handleAddEmoji} />
                        </div>
                    )}
                    </div>
                    <MessageInput
                        style={{ overflow: "auto", paddingLeft: "25px" }}
                        value={currentMessage}
                        onChange={handleChange}
                        onSend={handleSend}
                        disabled={!activeConversation}
                        sendDisabled={isBigImage}
                        sendOnReturnDisabled={isBigImage}
                        attachButton={false}
                        onAttachClick={togglePicker}
                        placeholder="Type here..."
                    />
                </div>

            </ChatContainer>
        </MainContainer>
    );

}